<template>
  <Drawer
    v-model:visible="drawerVisible"
    blockScroll
    modal
    position="bottom"
    :style="{ height: 'auto', maxHeight: '80vh', border: 'none' }"
    :pt="{
      content: '!p-0',
      root: { class: 'ratio-design-provider ft2-drawer', style: 'border-radius: 16px 16px 0 0' },
      header: { class: '!visible !hidden' },
    }"
  >
    <div v-if="config" class="flex flex-col items-center gap-8 px-8 pt-8 pb-12">
      <!-- Warning Icon -->
      <div class="flex flex-col items-center gap-2 w-full">
        <i class="ibi-warning-error-triangle text-[64px] text-[#E8A500]" />

        <!-- Title -->
        <p class="text-xl font-semibold text-on-surface text-center leading-6">
          {{ config.title }}
        </p>

        <!-- Position Summary -->
        <p class="text-sm text-center leading-[18px]">
          <template v-for="(pos, idx) in config.positions" :key="idx">
            <span v-if="idx > 0" class="text-on-surface-secondary"> · </span>
            <span :class="pos.side === 'yes' ? 'text-yes' : 'text-no'">
              {{ formatQuantity(pos.quantity) }} {{ pos.side === 'yes' ? 'Yes' : 'No' }}
            </span>
            <span class="text-on-surface-secondary"> @ {{ pos.displayName }}</span>
          </template>
        </p>
      </div>

      <!-- Disclaimer -->
      <p class="text-base text-on-surface text-center leading-5">
        {{ config.disclaimer }}
      </p>

      <!-- CTAs -->
      <div class="flex flex-col gap-2 w-full">
        <button
          v-for="(action, idx) in config.actions"
          :key="idx"
          :class="[
            'flex items-center justify-center h-10 w-full rounded-lg px-4 text-base cursor-pointer',
            action.variant === 'primary'
              ? 'bg-[var(--p-accent)] text-white'
              : 'bg-[var(--p-accent-subtle)] text-[var(--p-accent)]',
          ]"
          @click="$emit('action', idx)"
        >
          {{ action.label }}
        </button>
      </div>
    </div>
  </Drawer>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Drawer from 'primevue/drawer';
import type { SpeedBumpConfig } from '@/composables/useSpeedBump';

const props = defineProps<{
  visible: boolean;
  config: SpeedBumpConfig | null;
}>();

const emit = defineEmits<{
  'update:visible': [value: boolean];
  action: [index: number];
}>();

const drawerVisible = computed({
  get: () => props.visible,
  set: (value: boolean) => emit('update:visible', value),
});

function formatQuantity(qty: number): string {
  return qty.toLocaleString();
}
</script>
<!-- last modified by AI tools on 2026-10-07 -->
